<template lang="pug">
.would-you-like-to-block(@click="click" :style="{ 'background-image': `url(${data.image})` }")
  h4 {{ data.title }}
  p {{ data.message }}
</template>

<script>
export default {
  name: 'block',

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  methods: {
    click() {
      this.$emit('before-route')
      this.$router.push({ name: this.data.route })
    },
  },
}
</script>

<style lang="scss">
.would-you-like-to-block {
  cursor: pointer;
  width: 261px;
  height: 115px;
  padding: 20px;
  margin-bottom: 32px;
  background-size: cover;
  background-repeat: no-repeat;

  margin-right: 16px;
  @media(max-width: 569px) {
    margin-left: 16px;
  }
  @media(min-width: 570px) and (max-width: 846px) {
    &:nth-child(2n) {
      margin-right: 0;
    }
  }
  @media(min-width: 847px) {
    &:nth-child(3n) {
      margin-right: 0;
    }
  }

  > h4 {
    line-height: 20px;
    font-size: 16px;
    position: relative;
    &:before {
      content: '';
      display: inline-block;
      border: 1px solid #ffaa19;
      height: 30px;
      position: absolute;
      left: -21px;
      top: -7px;
    }
    &:after {
      content: '►';
      position: absolute;
      right: 0px;
      top: -1px
    }
  }
  > p {
    line-height: 22px;
  }
  &:hover > h4 {
    color: #ffaa19;
  }
}
</style>
